/* ÉNOIR — Landing Page Scripts */

document.addEventListener('DOMContentLoaded', function() {

  // Custom cursor
  var cursor = document.getElementById('enoir-cursor');
  var ring = document.getElementById('enoir-cursor-ring');
  if (cursor && ring) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px'; cursor.style.top = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * 0.1; ry += (my - ry) * 0.1;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('a, button').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cursor.style.transform = 'scale(2)'; ring.style.width = '50px'; ring.style.height = '50px'; });
      el.addEventListener('mouseleave', function() { cursor.style.transform = 'scale(1)'; ring.style.width = '36px'; ring.style.height = '36px'; });
    });
  }

  // Reveal on scroll
  document.querySelectorAll('.enoir-reveal').forEach(function(el) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.08 }).observe(el);
  });

  // Elder walk
  var heroElder = document.getElementById('enoir-elder');
  if (heroElder) {
    setTimeout(function() { heroElder.classList.add('visible'); }, 500);
    window.addEventListener('scroll', function() {
      var hero = document.querySelector('.enoir-hero');
      if (!hero) return;
      var p = Math.min(1, window.scrollY / hero.offsetHeight);
      heroElder.style.transform = 'translateX(' + (p * window.innerWidth * 0.85) + 'px)';
      var img = heroElder.querySelector('img');
      if (p > 0.6 && img) img.style.opacity = 1 - ((p - 0.6) / 0.4);
    });
  }

  // Family walk strip
  var wt = document.getElementById('enoir-walk-track');
  var ws = document.getElementById('enoir-walk-strip');
  if (wt && ws) {
    window.addEventListener('scroll', function() {
      var rect = ws.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, 1 - (rect.bottom / (window.innerHeight + rect.height))));
      wt.style.transform = 'translateX(' + (p * (window.innerWidth + 400) - 260) + 'px)';
    });
  }

});
